import React, { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import './Header.css';
import logo from '../../assets/images/logo.png';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, () => {
            // Reserved for future use if you want to react to auth state
        });
        return () => unsubscribe();
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen((open) => !open);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    return (
        <header className="header">
            <div className="header-content">
                <a href="/#top" className="brand-link" onClick={closeMenu} aria-label="Ashutosh Shashi home">
                    <img src={logo} alt="Ashutosh Shashi logo" className="logo" />
                    <span>Ashutosh Shashi</span>
                </a>

                <button
                    className="hamburger-menu"
                    onClick={toggleMenu}
                    aria-label="Toggle navigation"
                    aria-expanded={isMenuOpen}
                    aria-controls="primary-navigation"
                >
                    <span />
                </button>

                <nav id="primary-navigation" className={`navigation ${isMenuOpen ? 'active' : ''}`}>
                    <a href="/#introduction" className="nav-item" onClick={closeMenu}>
                        Home
                    </a>
                    <a href="/#publications" className="nav-item" onClick={closeMenu}>
                        Publications
                    </a>
                    <a href="/#knowledgeHub" className="nav-item" onClick={closeMenu}>
                        Knowledge Hub
                    </a>
                    <a href="/#resources" className="nav-item" onClick={closeMenu}>
                        Resources
                    </a>
                    <a href="/#contact" className="nav-item nav-contact" onClick={closeMenu}>
                        Contact
                    </a>
                </nav>
            </div>
        </header>
    );
};

export default Header;
